// @ts-ignore
/* eslint-disable */
import type { CustomRequestOptions } from '../customRequestOptions';
import { request } from '../axios/sdpSecurity';

/** 初始化登录密码修改 POST /mch/login/pwd/init */
export async function loginPwdInit(
  body: APISdpSecurity.LoginPwdInitRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpSecurity.ApiBaseResponse>('/mch/login/pwd/init', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 修改登录密码修改 POST /mch/login/pwd/modify */
export async function loginPwdModify(
  body: APISdpSecurity.LoginPwdModifyRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpSecurity.ApiBaseResponse>('/mch/login/pwd/modify', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 查询登录密码是否设置 GET /mch/login/pwd/modify/pre/check */
export async function modifyPreCheck(options?: CustomRequestOptions) {
  return request<APISdpSecurity.ApiDataResponseLoginPwdModifyPreCheckVO_>(
    '/mch/login/pwd/modify/pre/check',
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/** 查询登录密码是否设置 GET /mch/login/pwd/query */
export async function loginPwdQuery(options?: CustomRequestOptions) {
  return request<APISdpSecurity.ApiDataResponseLoginPwdSetupVO_>('/mch/login/pwd/query', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 重置登录密码修改 POST /mch/login/pwd/reset */
export async function loginPwdReset(
  body: APISdpSecurity.LoginPwdResetRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpSecurity.ApiBaseResponse>('/mch/login/pwd/reset', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
